import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import PreviewIcon from '@material-ui/icons/ImageSearch';
import CreateIcon from '@material-ui/icons/FileCopy';
import Typography from '@material-ui/core/Typography';
import PpiTable from '../../../../PpiList/PpiTable';
import { MARKET_GLOBAL_LANG } from '../../../../../features/app/constants';
import { ppiCreateFromExistingRoute } from '../../../../../routes';

const ListGlobalPpis = ({
  globalPpis,
  itemCode,
  openPreview,
  globalIngredientId
}) => {
  const { formatMessage } = useIntl();
  const history = useHistory();

  function createPpiFromExisting(ppiId, enrichmentId) {
    history.push(ppiCreateFromExistingRoute(ppiId, enrichmentId, itemCode));
  }

  const rows = globalPpis.map(globalPpi => {
    const ppiData = globalPpi.publishedPPIEnrichmentData;
    if (!ppiData) {
      console.warn('PPI Contains no Published Data', globalPpi);
      return {};
    }
    const { presentationName } = ppiData.info[MARKET_GLOBAL_LANG];

    const actions = (
      <>
        <Tooltip
          title={formatMessage({
            id: 'ppsi.previewInstructionTooltip'
          })}
        >
          <IconButton
            onClick={() => openPreview(ppiData, MARKET_GLOBAL_LANG)}
            color="secondary"
            size="medium"
          >
            <PreviewIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip
          title={formatMessage({
            id: 'ppi.createPpiFromGlobalActionTooltip'
          })}
        >
          <IconButton
            onClick={() => createPpiFromExisting(globalPpi.id, ppiData.id)}
            color="secondary"
            size="medium"
          >
            <CreateIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </>
    );

    // console.log("actions",actions)

    return {
      id: ppiData.id,
      name: presentationName,
      status: ppiData.enrichmentStatus,
      actions,
      globalIngredientId
    };
  });

  return (
    <>
      <Typography variant="body2">
        <FormattedMessage id="ppi.selectGlobalInstructionToCopy" />
      </Typography>
      <PpiTable rows={rows} />
    </>
  );
};

ListGlobalPpis.propTypes = {
  itemCode: PropTypes.string.isRequired,
  openPreview: PropTypes.func.isRequired
};

export default ListGlobalPpis;
